import React, { useEffect } from "react";
import { View360 } from "../components/Canvas/View360";
import { ContainerCard } from "../components/Container/ContainerCard";
import { HeaderLogo } from "../components/Header/HeaderLogo";
import { Loader } from "../components/Loader/Loader";
import { ModalInformation } from "../components/Modal/ModalInformation";
import { ModalViewImage } from "../components/Modal/ModalViewImage";
import Emitter from "../helpers/emitters";
import { useUiRedux } from "../hooks/useUiRedux";

export const Home = () => {
	const { goMoveLocationName } = useUiRedux();
	useEffect(() => {
		Emitter.on("movelocation", (data) => {
			goMoveLocationName(data);
		});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<>
			{/* <div
				className="absolute z-20 bottom-10 left-10 cursor-pointer"
				onClick={() => {
					Emitter.emit("onProcessObject", true);
				}}
			>
				Animation
			</div> */}
			{/* z10 */}
			<HeaderLogo />
			<ContainerCard />
			{/* z20 */}
			<ModalInformation />
			{/* z30*/}
			<ModalViewImage />
			{/* z40 */}
			<Loader />
			<View360 />
		</>
	);
};
